import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const MoreAskStory = (props) => {
  const { match } = props;

  return <ListStory page={Number(match.params.page)} type="askstories" />;
};

export default MoreAskStory;
